import { render, staticRenderFns } from "./MA2Print.vue?vue&type=template&id=5767f7e4&scoped=true&"
import script from "./MA2Print.vue?vue&type=script&lang=js&"
export * from "./MA2Print.vue?vue&type=script&lang=js&"
import style0 from "./MA2Print.vue?vue&type=style&index=0&id=5767f7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5767f7e4",
  null
  
)

export default component.exports